<template>
  <div v-if="!showFullWidget" class="indicator-text" v-bind:style="{ color: indicatorColor }">
    {{this.data.value}}
  </div>
  <div v-else class="widget-indicator-full" :style="{ '--widget-indicator-color': indicatorAccentColor }">
    <AppIcon :name="classIconFullWidget" :font-scale="1.75" :weight="500" :optical-size="40" />
    <div :class="classValueFullWidget">{{this.data.value}}</div>
    <div class="widget-indicator-title">{{this.data.title}}</div>
  </div>  
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
      colorText: {
        type: String,
        default: 'green'
      }
    },
    computed: {
      showFullWidget() {
        return this.data.type !== 'basic'
      },
      indicatorColor() {
        return this.data.color || this.colorText || 'var(--app-color-primary)'
      },
      indicatorAccentColor() {
        const variants = {
          success: 'var(--app-color-success)',
          warning: 'var(--app-color-warning)',
          danger: 'var(--app-color-danger)',
          info: 'var(--app-color-primary)',
          primary: 'var(--app-color-primary)'
        }

        return this.data.color || variants[this.data.variant] || this.colorText || 'var(--app-color-primary)'
      },
      classIconFullWidget() {
        const classes = ['fa', 'widget-indicator-icon']

        if(this.data.variant) {
          classes.push('bg-' + this.data.variant)
        }
        if(this.data.icon) {
          classes.push(this.data.icon)
        }

        return classes.join(' ')
      },
      classValueFullWidget() {
        const classes = ['widget-indicator-value']
        if(this.data.variant) {
          classes.push('text-' + this.data.variant)
        }
        return classes.join(' ')
      }
    }
  }
</script>

<style>
  .indicator-text {
    font-size: 2.25rem;
    font-weight: var(--app-font-bold);
    line-height: 1.1;
    text-align: center;
  }
  .widget-indicator-full {
    position: relative;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 14px;
    min-height: 84px;
    padding: 8px 6px 8px 14px;
  }
  .widget-indicator-full::before {
    content: "";
    position: absolute;
    top: 14px;
    bottom: 14px;
    left: 0;
    width: 3px;
    border-radius: 3px;
    background: var(--widget-indicator-color, var(--app-color-primary));
  }
  .widget-indicator-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 15px;
    color: var(--app-color-on-primary);
    box-shadow: var(--app-shadow-sm);
    font-size: 1.5rem;
  }
  .widget-indicator-value {
    overflow: hidden;
    color: var(--app-color-text);
    font-size: clamp(1.65rem, 2vw, 2rem);
    font-weight: var(--app-font-bold);
    letter-spacing: -0.035em;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .widget-indicator-title {
    grid-column: 2;
    margin-top: -17px;
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    letter-spacing: 0.07em;
    text-transform: uppercase;
  }
</style>
